module App.Interfaces {
    export interface ITime {
        time: string;
        available: number;
    }
}